import { render, staticRenderFns } from "./PmAddress.vue?vue&type=template&id=742f4f4f&scoped=true&"
import script from "./PmAddress.vue?vue&type=script&lang=js&"
export * from "./PmAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742f4f4f",
  null
  
)

export default component.exports